import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';
const DEFAULT_VERSION = 'NCC2111';

function getToken() {
  return localStorage.getItem('notes_token');
}
async function apiFetch(url, opts = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${url}`, { ...opts, headers: { ...(opts.headers || {}), 'x-token': token } });
  if (res.status === 401) { localStorage.removeItem('notes_token'); localStorage.removeItem('notes_user'); alert('登录超时，请重新登录'); window.location.href = '/'; return null; }
  return res;
}

export default function LogAnalysis() {
  const [versions, setVersions] = useState([]);
  const [version, setVersion] = useState(DEFAULT_VERSION);
  const [loading, setLoading] = useState(false);
  const [logResult, setLogResult] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  // 加载版本列表
  useEffect(() => {
    apiFetch('/api/dictionary/versions').then(res => res && res.json()).then(data => {
      if (data && data.success) setVersions(data.versions);
    });
  }, []);

  // 日志分析
  const analyzeLog = async () => {
    if (!selectedFile) return;
    setLoading(true);
    setLogResult(null);
    const formData = new FormData();
    formData.append('log', selectedFile);
    formData.append('version', version);
    try {
      const res = await apiFetch('/api/dictionary/analyze-log', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      setLogResult(data);
    } catch (e) {
      setLogResult({ success: false, error: e.message });
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: '24px' }}>
      {/* 标题 + 版本选择 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#1f2937', margin: 0 }}>
          📋 日志分析
        </h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontWeight: '500', color: '#374151', fontSize: '14px' }}>数据字典版本：</label>
          <select
            value={version}
            onChange={e => setVersion(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              fontSize: '13px',
              background: '#fff',
              cursor: 'pointer',
              outline: 'none'
            }}
          >
            {versions.map(v => (
              <option key={v.id} value={v.id}>{v.label}</option>
            ))}
          </select>
        </div>
      </div>

      {/* 上传区 */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{
          border: '2px dashed #d1d5db', borderRadius: '12px', padding: '40px', textAlign: 'center',
          background: '#f9fafb', cursor: 'pointer', transition: 'border-color 0.2s'
        }} onClick={() => document.getElementById('log-file-input').click()}
          onMouseEnter={e => e.currentTarget.style.borderColor = '#4f46e5'}
          onMouseLeave={e => e.currentTarget.style.borderColor = '#d1d5db'}>
          <input id="log-file-input" type="file" accept=".html,.htm" style={{ display: 'none' }}
            onChange={e => setSelectedFile(e.target.files[0])} />
          {selectedFile ? (
            <div style={{ color: '#4f46e5' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>📄</div>
              <div style={{ fontSize: '15px' }}>{selectedFile.name}</div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>{(selectedFile.size / 1024).toFixed(1)} KB · 点击更换</div>
            </div>
          ) : (
            <div style={{ color: '#6b7280' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>📁</div>
              <div style={{ fontSize: '15px' }}>点击上传SPR日志文件（HTML格式）</div>
              <div style={{ fontSize: '13px', marginTop: '4px' }}>支持 .html / .htm 格式</div>
            </div>
          )}
        </div>
        <button
          onClick={analyzeLog}
          disabled={loading || !selectedFile}
          style={{
            marginTop: '14px', padding: '12px 28px', border: 'none', borderRadius: '10px',
            background: loading || !selectedFile ? '#9ca3af' : '#4f46e5',
            color: '#fff', fontSize: '15px', cursor: loading ? 'wait' : 'pointer', fontWeight: '500', width: '100%'
          }}>
          {loading ? '分析中...' : '📋 分析日志'}
        </button>
      </div>

      {/* 日志分析结果 */}
      {logResult && (
        <div style={{ marginTop: '20px' }}>
          {logResult.analysis && (
            <div style={{ background: '#fff', border: '2px solid #e5e7eb', borderRadius: '12px', padding: '20px', marginBottom: '16px' }}>
              <div style={{ fontSize: '15px', fontWeight: '600', color: '#374151', marginBottom: '12px' }}>🤖 AI 分析结果</div>
              <div style={{ fontSize: '14px', color: '#374151', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>{logResult.analysis}</div>
            </div>
          )}
          {logResult.errors && logResult.errors.length > 0 && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '14px', marginBottom: '12px' }}>
              <div style={{ fontSize: '13px', fontWeight: '500', color: '#991b1b', marginBottom: '8px' }}>⚠️ 提取的错误信息</div>
              {logResult.errors.map((e, i) => (
                <div key={i} style={{ fontSize: '12px', color: '#7f1d1d', marginTop: '4px', whiteSpace: 'pre-wrap' }}>{e}</div>
              ))}
            </div>
          )}
          {logResult.sqls && logResult.sqls.length > 0 && (
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '14px', marginBottom: '12px' }}>
              <div style={{ fontSize: '13px', fontWeight: '500', color: '#166534', marginBottom: '8px' }}>📊 相关SQL</div>
              {logResult.sqls.map((s, i) => (
                <div key={i} style={{ fontSize: '12px', color: '#14532d', marginTop: '4px', whiteSpace: 'pre-wrap', fontFamily: 'JetBrains Mono, Consolas, monospace' }}>{s}</div>
              ))}
            </div>
          )}
          {logResult.tables && logResult.tables.length > 0 && (
            <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '12px' }}>
              涉及数据表：{logResult.tables.map((t, i) => (
                <span key={i} style={{ display: 'inline-block', background: '#eef2ff', borderRadius: '6px', padding: '3px 10px', margin: '3px 4px' }}>{t.name} ({t.desc})</span>
              ))}
            </div>
          )}
          {logResult.error && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '14px', color: '#991b1b' }}>❌ {logResult.error}</div>
          )}
        </div>
      )}
    </div>
  );
}
